/**
 * Firestore top-level collection names. Centralized so a rename is a
 * one-line change instead of a grep-and-pray across every module.
 */
export const COLLECTIONS = {
  USERS: 'users',
  PERMISSIONS: 'permissions',
  ADDRESSES: 'addresses',
  PRODUCTS: 'products',
  PRODUCT_VARIANTS: 'productVariants',
  BADGES: 'badges',
  TAXONOMIES: 'taxonomies',
  TERMS: 'terms',
  CONTENT_BLOCKS: 'contentBlocks',
  NAV_ITEMS: 'navItems',
  COLLECTIONS: 'collections',
  INVENTORY: 'inventory',
  CARTS: 'carts',
  ORDERS: 'orders',
  ORDER_SIGNALS: 'orderSignals',
  PAYMENTS: 'payments',
  PAYMENT_INTENTS: 'paymentIntents',
  COUPONS: 'coupons',
  WALLETS: 'wallets',
  WALLET_TRANSACTIONS: 'walletTransactions',
  GIFT_CARDS: 'giftCards',
  WISHLISTS: 'wishlists',
  REVIEWS: 'reviews',
  NOTIFICATIONS: 'notifications',
  GIFT_REMINDERS: 'giftReminders',
  REFERRALS: 'referrals',
  VENDORS: 'vendors',
  STORES: 'stores',
  DELIVERIES: 'deliveries',
  DELIVERY_ZONES: 'deliveryZones',
  DISCOUNTS: 'discounts',
  CMS_PAGES: 'cmsPages',
  BLOGS: 'blogs',
  FAQS: 'faqs',
  BANNERS: 'banners',
  AUDIT_LOGS: 'auditLogs',
  API_ERRORS: 'apiErrors',
  API_METRICS: 'apiMetrics',
  RELEASES: 'releases',
  RELEASE_RUNS: 'releaseRuns',
  RELEASE_STATE: 'releaseState',
  SETTINGS: 'settings',
} as const;

export type CollectionName = (typeof COLLECTIONS)[keyof typeof COLLECTIONS];
